<!-- Time Frame -->
<vrm-expansion-panel
  [panelTitle]="'GENERIC.timeFrame' | translate | uppercase"
  panelHeaderHeight='31px'
  [applyFormStyle]='true'
  [elevation]='0'
  [underlineHeading]='true'
  [panelExpanded]='timeFramePanelExpanded'
  [transparent]='true'
  [subtleTitle]='true'
  [applyFormStyle]='true'
  formStyleBorderColor='#ccc'
  sidePadding='10px'
  formStyleBorderWidth='1px'
  *ngIf='rptService.hasTimeFrameFilter'
>
  <div class='padding-10' fxLayout='column'>
    <div *ngIf='!cService.currentPageDateOrPeriod?.date?.hideCalendar'>
      <button
        mat-button
        class='sharp-corners'
        fxFlex
        [matMenuTriggerFor]='timeFrameFrequency'
        style='border-bottom: 1px solid #ccc'
      >
        {{
        cService.readyTranslations.generic[rptService.selectedTimeFrame.frequency.label.toLowerCase()]
          | uppercase
        }}
        <span fxFlex></span>
        <mat-icon style='position: relative; top: 5px; opacity: 0.6'>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #timeFrameFrequency='matMenu'>
        <button
          type='button'
          mat-menu-item
          *ngFor='let frequency of rptService.availableFrequencies'
          (click)='timeFrameFrequencyChanged(frequency)'
        >
          {{ cService.readyTranslations.generic[frequency.label.toLowerCase()] | uppercase }}
        </button>
      </mat-menu>
    </div>

    <mat-calendar
      #timeFrameCalendar
      class='time-frame-calendar'
      fxFlex
      [(selected)]='selectedDate'
      [headerComponent]='calendarHeader'
      (selectedChange)='selectedCalendarDateChanged($event)'
      (monthSelected)='selectedCalendarMonthChanged($event)'
      (yearSelected)='selectedCalendarYearChanged($event)'
      [dateFilter]='calendarFilter'
      *ngIf='!cService.currentPageDateOrPeriod?.date?.hideCalendar'
    >
    </mat-calendar>

    <div
      fxLayout='row'
      fxFlex
      *ngIf="
				selectedTimeSpan &&
				!selectedTimeSpan.toString().includes('1970') &&
				!cService.currentPageDateOrPeriod?.date?.hideCalendar
			"
    >
      <div fxLayout='row' class='selected-time-span-btn sharp-corners' fxFlex>
        <small *ngIf="rptService.selectedTimeFrame.frequency.value === 'year'">
          {{ selectedDate | momentDate: 'YYYY' }}
        </small>

        <small *ngIf="rptService.selectedTimeFrame.frequency.value === 'month'">
          {{ selectedDate | momentDate: 'YYYY MMMM' | translateDateMonth | uppercase }}
        </small>

        <small *ngIf="rptService.selectedTimeFrame.frequency.value === 'week'">
          {{ 'GENERIC.weekFrom' | translate }} &nbsp; {{ selectedDate | momentDate | translateDateMonth }}
        </small>

        <small *ngIf="rptService.selectedTimeFrame.frequency.value === 'day'">
          {{ selectedDate | momentDate | translateDateMonth | uppercase }}
        </small>
      </div>
    </div>

    <!-- Report data period -->
    <div
      *ngIf='
				cService.currentPageDateOrPeriod &&
				(cService.currentPageDateOrPeriod.date || cService.currentPageDateOrPeriod.dateComparison)
			'
      class='viewing-information-for'
    >
      <!-- Single date period -->
      <div *ngIf='cService.currentPageDateOrPeriod.date'>
        <div class='margin-b-10'>{{ 'GENERIC.viewingInformationFor' | translate }}:</div>

        <!-- Day -->
        <div *ngIf="cService.currentPageDateOrPeriod.date.period.toLowerCase() === 'day'">
          <div class='margin-b-5'>
            {{ 'GENERIC.day' | translate }}
          </div>

          {{
          cService.currentPageDateOrPeriod.date.startPeriod
            | momentDate: 'Do MMMM YYYY'
            | translateDateMonth
            | titlecase
          }}
        </div>

        <!-- Week -->
        <div *ngIf="cService.currentPageDateOrPeriod.date.period.toLowerCase() === 'week'">
          <div class='margin-b-5'>
            {{ 'GENERIC.weekBeginning' | translate }}
          </div>

          {{
          cService.currentPageDateOrPeriod.date.startPeriod
            | momentDate: 'Do MMMM YYYY'
            | translateDateMonth
            | titlecase
          }}
        </div>

        <!-- Month -->
        <div *ngIf="cService.currentPageDateOrPeriod.date.period.toLowerCase() === 'month'">
          <div class='margin-b-5'>
            {{ 'GENERIC.month' | translate }}
          </div>

          {{
          cService.currentPageDateOrPeriod.date.startPeriod
            | momentDate: 'MMMM YYYY'
            | translateDateMonth
            | titlecase
          }}
        </div>

        <!-- Year -->
        <div *ngIf="cService.currentPageDateOrPeriod.date.period.toLowerCase() === 'year'">
          <div class='margin-b-5'>
            {{ 'GENERIC.year' | translate }}
          </div>

          {{ cService.currentPageDateOrPeriod.date.startPeriod | momentDate: 'YYYY' | translateDateMonth }}
        </div>
      </div>

      <!-- Comparing two date periods -->
      <div *ngIf='cService.currentPageDateOrPeriod.dateComparison'>
        <div class='margin-b-10'>{{ 'GENERIC.comparing' | translate }}:</div>

        <!-- Day -->
        <div *ngIf="cService.currentPageDateOrPeriod.dateComparison.period.toLowerCase() === 'day'">
          <div class='margin-b-5'>
            {{
            cService.currentPageDateOrPeriod.dateComparison.currentPeriod
              | momentDate: 'Do MMMM YYYY'
              | translateDateMonth
            }}
          </div>
          <div class='margin-b-5'>
            {{ 'GENERIC.with' | translate }}
          </div>
          <div class='margin-b-5'>
            {{
            cService.currentPageDateOrPeriod.dateComparison.previousPeriod
              | momentDate: 'Do MMMM YYYY'
              | translateDateMonth
            }}
          </div>
        </div>

        <!-- Week -->
        <div *ngIf="cService.currentPageDateOrPeriod.dateComparison.period.toLowerCase() === 'week'">
          <div class='margin-b-5'>
            <div>{{ 'GENERIC.weekBeginning' | translate }}</div>
            {{
            cService.currentPageDateOrPeriod.dateComparison.currentPeriod
              | momentDate: 'Do MMMM YYYY'
              | translateDateMonth
            }}
          </div>
          <div class='margin-b-5'>
            {{ 'GENERIC.with' | translate }}
          </div>
          <div class='margin-b-5'>
            <div>{{ 'GENERIC.weekBeginning' | translate }}</div>
            {{
            cService.currentPageDateOrPeriod.dateComparison.previousPeriod
              | momentDate: 'Do MMMM YYYY'
              | translateDateMonth
            }}
          </div>
        </div>

        <!-- Month -->
        <div *ngIf="cService.currentPageDateOrPeriod.dateComparison.period.toLowerCase() === 'month'">
          <div class='margin-b-5'>
            {{
            cService.currentPageDateOrPeriod.dateComparison.currentPeriod
              | momentDate: 'MMMM YYYY'
              | translateDateMonth
            }}
          </div>
          <div class='margin-b-5'>
            {{ 'GENERIC.with' | translate }}
          </div>
          <div class='margin-b-5'>
            {{
            cService.currentPageDateOrPeriod.dateComparison.previousPeriod
              | momentDate: 'MMMM YYYY'
              | translateDateMonth
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</vrm-expansion-panel>

<!-- Selected row - Details -->
<vrm-expansion-panel
  panelTitle="{{ 'GENERIC.details' | translate | uppercase }}"
  panelHeaderHeight='31px'
  [elevation]='0'
  [underlineHeading]='true'
  [panelExpanded]='true'
  [transparent]='true'
  [subtleTitle]='true'
  [applyFormStyle]='true'
  formStyleBorderColor='#ccc'
  sidePadding='10px'
  formStyleBorderWidth='1px'
>
  <div class='padding-10'>
    <div *ngIf='selectedRowItems.length > 0 && !hideRowDetail; else userInformation'>
      <div class='margin-b-15' *ngFor='let item of selectedRowItems'>
        <div *ngIf="(item.uiValue || item.uiValue == '0' ) && item.uiColName !== 'PIN'">
          <div class='bold custom-panel-heading'>{{ item.uiColName }}</div>
          <div style='padding-top: 3px' [class.bold]='item.color' [style.color]='item.color'>
            {{ item.uiValue }}
          </div>
        </div>
      </div>
    </div>
    <ng-template mentor-render-component></ng-template>

    <ng-template #userInformation>
      <div style='opacity: 0.6' class='margin-t-20'>
        <p>{{ 'MESSAGESANDWARNINGS.clickRowToView' | translate }}</p>
      </div>
    </ng-template>
  </div>
</vrm-expansion-panel>
